import { colorConstants } from 'config/colorConstants';

const DownloadIcon = ({
    stroke = colorConstants.blackAlt,
    width = 16,
    height = 16,
}: {
    stroke?: string;
    width?: number;
    height?: number;
}) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00016 1.33325C8.36835 1.33325 8.66683 1.63173 8.66683 1.99992V9.72378L11.5288 6.86185C11.7891 6.6015 12.2112 6.6015 12.4716 6.86185C12.7319 7.1222 12.7319 7.54431 12.4716 7.80466L8.47157 11.8047C8.21122 12.065 7.78911 12.065 7.52876 11.8047L3.52876 7.80466C3.26841 7.54431 3.26841 7.1222 3.52876 6.86185C3.78911 6.6015 4.21122 6.6015 4.47157 6.86185L7.3335 9.72378V1.99992C7.3335 1.63173 7.63197 1.33325 8.00016 1.33325ZM1.3335 13.9999C1.3335 13.6317 1.63197 13.3333 2.00016 13.3333H14.0002C14.3684 13.3333 14.6668 13.6317 14.6668 13.9999C14.6668 14.3681 14.3684 14.6666 14.0002 14.6666H2.00016C1.63197 14.6666 1.3335 14.3681 1.3335 13.9999Z"
            fill={stroke}
        />
    </svg>
);

export default DownloadIcon;